import { createContext } from 'react';
import type { SizeAndWidthContextType } from './SizeAndWidthContextType';

export const SizeAndWidthContext = createContext<SizeAndWidthContextType>({
  selectedSize: '',
  handleChangeSize: () => () => {},
  selectedWidth: '',
  handleChangeWidth: () => () => {},
  selectedSku: '',
  error: [],
  setError: () => {},
  isSubdomainOutlet: false,
  uniqueWidths: [],
  uniqueSizes: [],
  variants: [],
  isNotifyMeOpen: false,
  setNotifyMeVisibility: () => {},
  noResultsFound: false,
  setNoStockResultsFound: () => {},
  isProductSoldOutOnline: false,
  isSelectedVariantOutOfStock: false,
  isSelectedVariantWithNotificationEnabled: false,
});
